import {INIT_URL, SIGNOUT_USER_SUCCESS, USER_DATA, USER_TOKEN_SET} from "../../constants/ActionTypes";

const readStorageItem = (key) => {
  if (typeof window === "undefined") return null;
  const sessionValue =
    typeof sessionStorage !== "undefined" ? sessionStorage.getItem(key) : null;
  if (sessionValue !== null) return sessionValue;
  return localStorage.getItem(key);
};

const readToken = () => {
  try { return JSON.parse(readStorageItem('token')); } catch (e) { return null; }
};
const readUser = () => {
  try { return JSON.parse(readStorageItem('user')); } catch (e) { return null; }
};

/* MİSAFİR ARTIK SAHTE KİMLİK DEĞİL. Eskiden token yoksa uydurma bir "Misafir"
   kullanıcısı basıyorduk (tenantı yok, verisi yok). Yeni akışta sayfa açılınca
   sunucuda geçici ama GERÇEK bir hesap doğuyor (actions/Auth → guestSignIn);
   kimlik oradan, tıpkı normal girişteki gibi geliyor. */
const token0 = readToken();
const user0 = readUser();

const INIT_STATE = {
  token: token0,
  initURL: '',
  authUser: token0 ? user0 : null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {


    case INIT_URL: {
      return {...state, initURL: action.payload};
    }

    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        token: null,
        authUser: null,
        initURL: ''
      }
    }

    case USER_DATA: {
      return {
        ...state,
        authUser: action.payload,
      };
    }

    case USER_TOKEN_SET: {
      return {
        ...state,
        token: action.payload,
      };
    }

    default:
      return state;
  }
}
